import React, { useState } from 'react'
import { Link } from 'react-router-dom';

function Documents({ activeNav, setActiveNav }) {
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('News');

    return (
        <div className='main-content'>
            <header className="top-header">
                <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                    <Link className="logo">
                        <img src='https://images.seeklogo.com/logo-png/38/2/coding-logo-png_seeklogo-384586.png' alt='' />
                        <span>MMao</span>
                    </Link>
                    <div className="search-box">
                        <i class="ri-search-line"></i>
                        <input
                            type="text"
                            placeholder="Search blog, documents..."
                            value={searchQuery}
                            maxLength={45}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                </div>
            </header>
            <div className="page-title-row">
                <h1 className="page-title">Documents</h1>
                <div className="filter-tabs">
                    {['News', 'Documents', 'Terms & Conditions'].map((tab) => (
                        <button
                            key={tab}
                            className={`filter-tab ${activeTab === tab ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            </div>
            <div className='document-list'>
                <Link>
                    <div className='document-title'>
                        <h3>sdkfjlj</h3>
                        <p><i class="ri-calendar-event-line"></i>klsdfkl</p>
                    </div>
                    <div className='detail'>
                        <h3>💌</h3>
                    </div>
                </Link>
            </div>
            <nav className="bottom-nav-menu">
                {[
                    { name: 'Home', icon: 'ri-home-3-fill' },
                    { name: 'My courses', icon: 'ri-folder-video-fill' },
                    { name: 'Documents', icon: 'ri-article-fill' },
                    { name: 'Reviews', icon: 'ri-chat-ai-4-fill' },
                    { name: 'Profile', icon: 'ri-user-3-fill' }
                ].map((item) => (
                    <button
                        key={item.name}
                        className={`bottom-nav-item ${activeNav === item.name ? 'active' : ''}`}
                        onClick={() => setActiveNav(item.name)}
                    >
                        <i class={item.icon}></i>
                        <span>{item.name}</span>
                    </button>
                ))}
            </nav>
        </div>
    )
}

export default Documents